export const STORAGE_KEY = 'weez_export_notifications';

// Exports are usually ready within a few seconds, so start polling fast to notify the user as soon
// as possible, then back off to keep long running exports cheap for both the browser and the API.
export const FIRST_INTERVAL = 1000;
export const MAX_INTERVAL = 15000;
export const BACKOFF_FACTOR = 1.5;

// A single failed request is usually transient (a blip, or a request aborted by a page change), so
// only give up on an export once it has failed repeatedly.
export const MAX_POLL_FAILURES = 3;

// Safety net: an export that never reaches a final state should not be polled forever.
export const MAX_TRACKING_DURATION = 60 * 60 * 1000;

export const DONE = 'done';
// The export will not complete on its own: it either failed or needs the user to act on it.
export const NEEDS_ATTENTION_STATUSES = ['not-valid', 'action-required'];
